import React, { useEffect, useState, useRef } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Clear } from "@material-ui/icons";
import SelectDropdown from "./SelectDropdown";

export default function Slots({
  getOptions,
  addButton,
  removeButton,
  currentConfig,
  updateDefaultButton,
  heirarchy,
  showCreateSlot = false,
  onCreateSlot,
}) {
  const radioRef = useRef(null);
  const [slots, setSlots] = useState([
    ...(currentConfig?.menu ?? []).filter((slot) => slot.enabled !== false),
  ]);
  const [checked, setChecked] = useState(0);
  useEffect(() => {
    const existingSlots = [
      ...(currentConfig?.menu ?? []).filter((slot) => slot.enabled !== false),
    ];
    setSlots(existingSlots);
  }, [currentConfig?.menu]);

  // eslint-disable-next-line no-unused-vars
  const addSlot = (slot) => {
    const currentSlots = slots;
    if (currentSlots.length === 0 && heirarchy.length > 0) slot.default = 1;
    currentSlots.push(slot);
    setSlots([...currentSlots]);
    addButton(slot);
  };
  const removeSlot = (slot) => {
    const currentSlots = slots;
    const slotIndex = currentSlots.findIndex((e) => e.name === slot.name);
    currentSlots.splice(slotIndex, 1);
    setSlots([...currentSlots]);
    removeButton(slot.name);
  };

  return (
    <div className="slotContainer">
      <div className="addSlots">
        <SelectDropdown
          isSearchable
          className="selectSlots"
          menuList={getOptions()
            .map((m) => m.name)
            .filter(
              (m) =>
                !slots?.map((existingMenu) => existingMenu.name).includes(m)
            )}
          placeholder="Add New Slots"
          onMenuSelect={(data) => {
            console.log("add slot called", data);
            const slotConfig = getOptions().find((e) => e.name === data);
            addSlot(slotConfig);
          }}
        />
        {showCreateSlot && (
          <OverlayTrigger
            key="bottom"
            placement="bottom"
            overlay={<Tooltip id="tooltip-bottom">Create New Slot</Tooltip>}
          >
            <Button
              className="addSlotAction"
              variant="secondary"
              onClick={() => {
                onCreateSlot();
              }}
            >
              +
            </Button>
          </OverlayTrigger>
        )}
      </div>
      <div className="existingSlots">
        {slots?.map((item, index) => {
          const keyIndex = `${item.name}_${index}`;
          return (
            <div className="slotItemContainer" key={keyIndex}>
              {heirarchy.length > 0 && (
                <OverlayTrigger
                  target={radioRef.current}
                  overlay={(props) => (
                    <Tooltip id="tooltip-bottom" {...props}>
                      Set as Default
                    </Tooltip>
                  )}
                >
                  <input
                    ref={radioRef}
                    type="radio"
                    name="slot"
                    id={item.name}
                    checked={item.default === 1}
                    onChange={() => {
                      setChecked(checked + 1);
                      updateDefaultButton(item.name);
                    }}
                  />
                </OverlayTrigger>
              )}
              <div className="slot" key={item.name}>
                <img src={item?.icon} alt="slots" width="32" height="32" />
                <div className="slotName">{item.name}</div>
                <Button
                  className="clearAction"
                  variant="secondary"
                  onClick={() => removeSlot(item)}
                >
                  <Clear fontSize="small" />
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
